"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3" };
const _hoisted_3 = { class: "flex flex-col md:flex-row" };
const _hoisted_4 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_5 = { class: "w-full text-base pt-3" };
const _hoisted_6 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_7 = { class: "flex items-center" };
const _hoisted_8 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_9 = { class: "inline font-bold uppercase text-base" };
const _hoisted_10 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_11 = { class: "w-56 text-base pt-3" };
const _hoisted_12 = { class: "flex flex-col md:flex-row" };
const _hoisted_13 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_14 = { class: "w-full text-base pt-3" };
const _hoisted_15 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_16 = { class: "flex items-center" };
const _hoisted_17 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_18 = { class: "inline font-bold uppercase text-base" };
const _hoisted_19 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_20 = { class: "w-56 text-base pt-3" };
const _hoisted_21 = { class: "flex flex-col md:flex-row" };
const _hoisted_22 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_23 = { class: "w-full text-base pt-3" };
const _hoisted_24 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_25 = { class: "flex items-center" };
const _hoisted_26 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_27 = { class: "inline font-bold uppercase text-base" };
const _hoisted_28 = { class: "flex flex-col md:flex-row" };
const _hoisted_29 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_30 = { class: "w-full text-base pt-3" };
const _hoisted_31 = { class: "inline-flex items-start mr-2" };
const _hoisted_32 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_33 = { class: "inline font-bold uppercase text-base" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BasicInformationsForm',
    props: {
        guaranteeProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (__props.guaranteeProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("basic_informations", "Basic Informations", "guarantee_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_accident", "Did the error cause accident?", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_accident_no", "No", "guarantee_product_return")), 1),
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        modelValue: __props.guaranteeProductReturnCreateRequest.causedAccident,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.guaranteeProductReturnCreateRequest.causedAccident) = $event)),
                                        class: "mx-3"
                                    }, null, 8, ["modelValue"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_accident_yes", "Yes", "guarantee_product_return")), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("purchase_date", "Purchase Date", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                type: "date",
                                required: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isPurchaseDateValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('purchase_date_required', 'Purchase date required', 'guarantee_product_return'),
                                max: "9999-12-31",
                                modelValue: __props.guaranteeProductReturnCreateRequest.purchaseDate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((__props.guaranteeProductReturnCreateRequest.purchaseDate) = $event))
                            }, null, 8, ["valid", "invalid-message", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_injury", "Did the error cause personal injury?", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_injury_no", "No", "guarantee_product_return")), 1),
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        modelValue: __props.guaranteeProductReturnCreateRequest.causedPersonalInjury,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((__props.guaranteeProductReturnCreateRequest.causedPersonalInjury) = $event)),
                                        class: "mx-3"
                                    }, null, 8, ["modelValue"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_injury_yes", "Yes", "guarantee_product_return")), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_19, [
                            (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_invoice_id", "Customer Invoice Id", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                required: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isCustomerInvoiceIdValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('customer_invoice_id_required', 'Customer invoice ID required', 'guarantee_product_return'),
                                modelValue: __props.guaranteeProductReturnCreateRequest.customerInvoiceId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((__props.guaranteeProductReturnCreateRequest.customerInvoiceId) = $event))
                            }, null, 8, ["valid", "invalid-message", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                            (0, vue_2.createElementVNode)("div", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("require_tyre_return", "If the tyre is rejected, do you want it returned?", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                (0, vue_2.createElementVNode)("div", _hoisted_25, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("require_tyre_return_no", "No", "guarantee_product_return")), 1),
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        modelValue: __props.guaranteeProductReturnCreateRequest.requireTyreReturn,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((__props.guaranteeProductReturnCreateRequest.requireTyreReturn) = $event)),
                                        class: "mx-3"
                                    }, null, 8, ["modelValue"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_27, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("require_tyre_return_yes", "Yes", "guarantee_product_return")), 1)
                                ])
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_28, [
                        (0, vue_2.createElementVNode)("div", _hoisted_29, [
                            (0, vue_2.createElementVNode)("div", _hoisted_30, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_material_damage", "Is there any material damage?", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_material_damage_no", "No", "guarantee_product_return")), 1),
                                (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                    modelValue: __props.guaranteeProductReturnCreateRequest.causedMaterialDamage,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((__props.guaranteeProductReturnCreateRequest.causedMaterialDamage) = $event)),
                                    class: "mx-3"
                                }, null, 8, ["modelValue"]),
                                (0, vue_2.createElementVNode)("div", _hoisted_33, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("caused_material_damage_yes", "Yes", "guarantee_product_return")), 1)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                            modelValue: __props.guaranteeProductReturnCreateRequest.customerComplaint,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((__props.guaranteeProductReturnCreateRequest.customerComplaint) = $event)),
                            border: "",
                            "label-class": "text-base mb-3",
                            "show-validity": true,
                            valid: __props.guaranteeProductReturnCreateRequest.isCustomerComplaintValid(),
                            "invalid-message": (0, vue_2.unref)(i18n_1.trans)('customer_complaint_required', 'Customer complaint required', 'guarantee_product_return'),
                            label: (0, vue_2.unref)(i18n_1.trans)('customer_complaint', 'Customer Complaint', 'guarantee_product_return'),
                            rows: 4
                        }, null, 8, ["modelValue", "valid", "invalid-message", "label"])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
